import * as Constants from './constants'
import * as Types from './types'

export const toggleSubNavMobile = (href: Types.Href) =>
  ({type: Constants.TOGGLE_SUBNAV_MOBILE, href})

export const toggleMainMenuMobile = () => ({type: Constants.TOGGLE_MAIN_MENU_MOBILE})



// WEBPACK FOOTER //
// ./src/components/menu/left-nav/actions.ts